export default __webpack_public_path__ + "static/media/grafema_recta-intencao-book_07.0e86be40.jpg";